import { createAction, createReducer } from "@reduxjs/toolkit";
import frc from 'front-end-common';
import LostAndFoundService from "../Services/LostAndFoundService";

const { addDefaultHandlers, getDefaultState } = frc.utils.reducerTools;


export const lostAndFoundListFetch = createAction('lostAndFound/list', (params) => ({
  payload: LostAndFoundService.getLostAndFoundList(params)
}))

export const setLostOrFound = createAction('virtualMachines/edit', (params) => ({
  payload: LostAndFoundService.editLostOrFound(params)
}))

export const groupChangeLostAndfound = createAction('lostAndFound/group-edit', (params) => ({
  payload: LostAndFoundService.groupEditLostAndFound(params)
}))

const initialState = {
  list: getDefaultState(),
  edit: getDefaultState(),
  groupEdit: getDefaultState(),
}

export default createReducer(initialState, (builder) => {
  addDefaultHandlers(builder, lostAndFoundListFetch, 'list');
  addDefaultHandlers(builder, setLostOrFound, 'edit');
  addDefaultHandlers(builder, groupChangeLostAndfound, 'groupEdit');
})
